// Integración con HubSpot para captura de leads.
// Usa la Forms Submission API (pública, sin token) para crear/actualizar un
// contacto en HubSpot cada vez que un hotel se registra en la plataforma.
//
// IMPORTANTE: cada campo enviado debe existir en el formulario de HubSpot
// (portal 244382946 / form e9794e90-...). Si un campo no está en el form,
// HubSpot rechaza toda la sumisión. Campos usados: email, firstname,
// company, mobilephone, country, address.
// Nota: el teléfono del encargado (celular/WhatsApp) va a `mobilephone`
// ("Número de móvil"), no a `phone` ("Número de teléfono").

const HUBSPOT_PORTAL_ID = '244382946';
const HUBSPOT_FORM_GUID = 'e9794e90-bbf8-4758-b548-b2cb472acf8d';
const HUBSPOT_ENDPOINT = `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${HUBSPOT_FORM_GUID}`;

// Propiedad personalizada que etiqueta el origen del lead. El nombre interno
// (LEAD_SOURCE_PROPERTY) debe coincidir EXACTO con el de HubSpot y estar
// agregado al formulario, o la Forms API rechaza toda la sumisión.
const LEAD_SOURCE_PROPERTY = 'origen_segocloud';
const LEAD_SOURCE_VALUE = 'Registro PMS SegoCloud';

// Lee una cookie por nombre (para la cookie de tracking de HubSpot).
const readCookie = (name) => {
  if (typeof document === 'undefined') return '';
  const match = document.cookie.match(new RegExp('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)'));
  return match ? match.pop() : '';
};

/**
 * Envía un lead a HubSpot a partir de los datos de registro del hotel.
 * Es "fire and forget": nunca lanza; si falla, solo lo registra en consola
 * para no afectar el flujo de registro del usuario.
 *
 * @param {Object} data - Datos del hotel registrado.
 * @param {string} data.email
 * @param {string} [data.managerName] - Persona encargada -> firstname
 * @param {string} [data.name] - Nombre del hotel -> company
 * @param {string} [data.managerPhone] - Teléfono internacional -> mobilephone
 * @param {string} [data.country]
 * @param {string} [data.address]
 */
export const submitHubspotLead = async ({ email, managerName, name, managerPhone, country, address } = {}) => {
  try {
    if (!email) return; // email es obligatorio en cualquier formulario de HubSpot

    // Solo se envían los campos con valor para minimizar rechazos.
    const fields = [
      { name: 'email', value: email },
      { name: 'firstname', value: managerName },
      { name: 'company', value: name },
      { name: 'mobilephone', value: managerPhone },
      { name: 'country', value: country },
      { name: 'address', value: address },
      // Origen fijo del lead (propiedad personalizada en HubSpot).
      { name: LEAD_SOURCE_PROPERTY, value: LEAD_SOURCE_VALUE }
    ].filter((f) => f.value);

    const hutk = readCookie('hubspotutk');

    const body = {
      fields,
      context: {
        pageUri: typeof window !== 'undefined' ? window.location.href : undefined,
        pageName: typeof document !== 'undefined' ? document.title : undefined,
        ...(hutk ? { hutk } : {})
      }
    };

    const res = await fetch(HUBSPOT_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });

    if (!res.ok) {
      const detail = await res.text().catch(() => '');
      console.error('HubSpot lead rechazado:', res.status, detail);
    }
  } catch (err) {
    // No propagar: el lead es secundario al registro del hotel.
    console.error('Error enviando lead a HubSpot:', err);
  }
};

export default submitHubspotLead;
